import React from "react";
import { Helmet } from "react-helmet-async";
import { Stack, Box, TextField } from "@mui/material";

import SaveIcon from "@mui/icons-material/Save";

import useApiKey from "../../../hooks/super/useApiKey";
import useAuth from "../../../hooks/useAuth";

import AbuseIpDbApiKeyHistoryList from "./component/T_AbuseIpDbApiKeyHistory";
import { CollapseAlert } from "../../../components/pages/common/styled";
import { UserType } from "../../../utils/constants";

import PageHeader from "../../../components/pages/_new/super/common/PageHeader";
import PrimaryButton from "../../../components/pages/_new/super/common/PrimaryButton";
import {
  TOKENS,
  SectionCard,
} from "../../../components/pages/_new/super/design";

function SAAbuseIpDbApiKey() {
  const { getAbuseIpDbApiKeyHistory, apiSize, insertAbuseIpDbApiKey, errMsg, setErr } = useApiKey();
  const { isAuthenticated, adminUserType } = useAuth();

  const apikeyRef = React.useRef(null);
  const [abuseIpDbApiKeyValue, setAbuseIpDbApiKeyValue] = React.useState("");
  const saveAbuseIpDbApiKey = () => {
    if (!abuseIpDbApiKeyValue) {
      apikeyRef.current?.focus();
      return;
    }
    insertAbuseIpDbApiKey(abuseIpDbApiKeyValue);
    setAbuseIpDbApiKeyValue("");
  };
  const changeAbuseIpDbApiKey = (e) => setAbuseIpDbApiKeyValue(e.target.value);

  React.useEffect(() => {
    if (isAuthenticated) getAbuseIpDbApiKeyHistory(apiSize, 0);
    return () => setErr(null);
  }, [isAuthenticated, apiSize, getAbuseIpDbApiKeyHistory, setErr]);

  const [errOpen, setErrOpen] = React.useState(false);
  React.useEffect(() => {
    if (errMsg) setErrOpen(true);
  }, [errMsg]);

  const isSuper = UserType.SUPER_ADMIN === adminUserType;

  return (
    <React.Fragment>
      <Helmet title="SA AbuseIPDB API Key" />
      <PageHeader
        title="AbuseIPDB API Key"
        description="AbuseIPDB reputation key used by the WAF to enrich IP intelligence"
      />
      <Box sx={{ mb: 3 }}>
        <CollapseAlert errOpen={errOpen} setErrOpen={setErrOpen} setErr={setErr} errMsg={errMsg} />
      </Box>

      <Stack spacing={2}>
        <SectionCard title="Current API key" description="Rotate by entering a new key and clicking Save">
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} sx={{ maxWidth: 720 }}>
            <TextField
              fullWidth
              size="small"
              placeholder="AbuseIPDB API key"
              required
              value={abuseIpDbApiKeyValue}
              onChange={changeAbuseIpDbApiKey}
              inputRef={apikeyRef}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: `${TOKENS.radiusXs}px`,
                  background: TOKENS.bgSurface,
                },
              }}
            />
            <PrimaryButton
              onClick={saveAbuseIpDbApiKey}
              startIcon={<SaveIcon style={{ width: 18, height: 18 }} />}
              disabled={!isSuper}
            >
              Save
            </PrimaryButton>
          </Stack>
        </SectionCard>

        <SectionCard title="Recent API keys" description="History of AbuseIPDB key rotations">
          <AbuseIpDbApiKeyHistoryList />
        </SectionCard>
      </Stack>
    </React.Fragment>
  );
}
export default SAAbuseIpDbApiKey;
